export default __webpack_public_path__ + "static/media/ETEF-8.9d998242.pdf";